import webuiState from "../app/InternalStateService";
import {
    findInWidgetState,
    getDependentPaths,
    extractEntityData,
    extractStorePath,
    getEntityPath,
    getStorePathWidgetId
} from "../utils/storeUtils";
import { createFormData } from "../utils/dataUtils";
import { constructRequestEntity } from "../utils/dataUtils";
import { loadInnerWidgets } from "./Loader";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export const SET = "SET";
export const SET_CONFIG = "SET_CONFIG";

export const SET_MULTIPLE_PROPERTIES = "SET_MULTIPLE_PROPERTIES";
export const MULTIPLE_SET = "MULTIPLE_SET";
export const SET_PROPERTIES = "SET_PROPERTIES";
export const SET_MULTIPLE_DATA = "SET_MULTIPLE_DATA";

const UPLOAD_FILES_REQUEST = "UPLOAD_FILES_REQUEST";
const UPLOAD_FILES_SUCCESS = "UPLOAD_FILES_SUCCESS";

export const SET_UISTATE = "SET_UISTATE";
export const CLEAR_UISTATE = "CLEAR_UISTATE";
export const CLEAR_UISTATE_DEEP = "CLEAR_UISTATE_DEEP";
export const CLEAR_UISTATE_VALIDATIONS_DEEP = "CLEAR_UISTATE_VALIDATIONS_DEEP";
export const SET_UISTATES = "SET_UISTATES";
export const WIDGET_DATA_SUCCESS = "WIDGET_DATA_SUCCESS";

export function saveState(widgetId, componentId, truePath, newState, uiState) {
    return dispatch => {
        let storePath = Array.from(truePath);
        storePath.pop();
        dispatch(triggerSet([widgetId, ...truePath], newState));
        dispatch(triggerSet([widgetId, ...storePath], uiState));
        return dispatch(setUiState(widgetId, componentId, uiState));
    };
}
//[{path:[entityPath], state: {data}}]
// set one data to the entity data and to ui state
export function saveMultipleStates(newState) {
    return (dispatch, getState) => {
        dispatch(triggerMultipleSetData(newState));
        //ui state needs container computedBindTo
        let computedPathState = newState.map(state => {
            if (state.hasOwnProperty("path")) {
                let widgetId = state.path[0]; // by default the true path first item is the widget id
                let computedBindTo = getEntityPath(state.path, getState());
                return Object.assign({}, state, {
                    path: [widgetId, computedBindTo]
                });
            }
            return state;
        });
        return dispatch(triggerMultipleSetUiState(computedPathState));
    };
}

//[{path:[], state: {data}}]
export function triggerMultipleSetData(entityStates) {
    return {
        type: SET_MULTIPLE_DATA,
        payload: entityStates
    };
}
/* UI state actions */
export function setUiState(widgetId, componentId, newState) {
    return {
        type: SET_UISTATE,
        payload: {
            widgetId: widgetId,
            componentId: componentId,
            newState: newState
        }
    };
}

export function clearUiState(widgetId, componentId) {
    return {
        type: CLEAR_UISTATE,
        payload: {
            widgetId: widgetId,
            componentId: componentId
        }
    };
}

export function clearUiStateDeep(widgetId, componentId) {
    return {
        type: CLEAR_UISTATE_DEEP,
        payload: {
            widgetId: widgetId,
            componentId: componentId
        }
    };
}

export function clearUiStateValidationsDeep(widgetId, componentId) {
    return {
        type: CLEAR_UISTATE_VALIDATIONS_DEEP,
        payload: {
            widgetId: widgetId,
            componentId: componentId
        }
    };
}

export function triggerMultipleSetUiState(entityStates) {
    return {
        type: "SET_UISTATES",
        payload: entityStates
    };
}

/* Individual fields binding actions */

function set(path, value, options) {
    //var index = options && options.index ? options.index : 0;
    return {
        type: SET,
        payload: {
            path: path,
            toSet: value,
            ...options
        }
    };
}

export function triggerSet(path, value, options) {
    return dispatch => {
        return dispatch(set(path, value, options));
    };
}

export function triggerCopy(fromPath, toPath, options) {
    return (dispatch, getState) => {
        var state = getState();
        var targetData = state.getIn(["data", ...fromPath]);
        return dispatch(set(toPath, targetData, options));
    };
}

function setConfig(path, value, options) {
    return {
        type: SET_CONFIG,
        payload: {
            path: path,
            toSet: value,
            ...options
        }
    };
}

export function triggerSetConfig(path, value, options) {
    return dispatch => {
        return dispatch(setConfig(path, value, options));
    };
}

export function triggerSetInSession(key, value, options) {
    return {
        type: "SET_IN_SESSION",
        payload: {
            key: key,
            value: value
        }
    };
}

export function updateComponentValue(sirenAction, widgetId, path) {
    let dependencies = sirenAction.dependencies || [];
    let dependencyPaths = [];

    if (!dependencies.length) {
        return Promise.reject("updateComponentValue action failed: missing dependecies.");
    }

    return (dispatch, getState) => {
        dependencyPaths = getDependentPaths(dependencies, getState(), path);

        if (!dependencyPaths.length) {
            return Promise.reject(
                "updateComponentValue action failed: no correct dependencies found"
            );
        }

        let sourceState = findInWidgetState(getState().getIn(["data", widgetId]), path.split("."));
        let newValue = {
            value: sourceState.getIn(["properties", "value"])
        };

        return dispatch(triggerMultipleSetProperties(dependencyPaths, newValue));
    };
}

export function triggerMultipleSetProperties(targets, newProperties) {
    return {
        type: SET_MULTIPLE_PROPERTIES,
        payload: {
            targets: targets,
            newProperties: newProperties
        }
    };
}
export function triggerMultipleSet(targets, data) {
    return {
        type: MULTIPLE_SET,
        payload: {
            targets,
            data
        }
    };
}
//allows to set different properties to several entities
//expected format: [{path: truePath, properties: {value: "123"}}]
export function triggerSetIndependentProperties(entitiesProperties) {
    return {
        type: SET_PROPERTIES,
        payload: entitiesProperties
    };
}

export function uploadFiles(sirenAction, widgetId, path) {
    return async (dispatch, getState) => {
        let endpoint =
            sirenAction.href ||
            webuiState.getActionByName("widget.getWidgetUrl")(widgetId, getState());
        let fileUploadData = extractEntityData(path, getState()).toJS();
        let files = fileUploadData.properties.value.files || [];
        let payload = createFormData({}, sirenAction, undefined, widgetId);
        payload.append("action", "uploadFiles");
        for (let index in files) {
            payload.append("file", files[index], files[index].name);
        }
        let actionResult;
        try {
            await dispatch({
                type: UPLOAD_FILES_REQUEST
            });
            await dispatch(webuiState.getActionByName("loading.triggerGlobalLoading")(true));
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "POST",
                        endpoint: endpoint,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            await dispatch({
                type: UPLOAD_FILES_SUCCESS,
                payload: actionResult
            });
        } catch (error) {
            actionResult = Promise.reject(error);
        } finally {
            dispatch(webuiState.getActionByName("loading.dismissGlobalLoading")());
        }
        return actionResult;
    };
}

//the result of this action is another, that should be triggered
export function requestAction(sirenAction, widgetId, path) {
    return (dispatch, getState) => {
        let widgetData = getState().getIn(["data", widgetId]);
        if (widgetData.toJS) {
            let payload;

            payload = createFormData(widgetData.toJS(), sirenAction, undefined, widgetId);
            payload.append("action", sirenAction.actionType);
            return dispatch(requestActionDispatch(widgetId, path, sirenAction.href, payload));
        }
        Promise.reject("request action has failed");
    };
}
function requestActionDispatch(widgetId, path, endpoint, payload) {
    return async dispatch => {
        let actionResult = await dispatch(
            webuiState.getActionByName("request.request")(
                {
                    method: "POST",
                    endpoint: endpoint,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    payload: payload
                },
                {
                    widgetId: widgetId
                }
            )
        );
        if (actionResult.class && actionResult.class.includes(widgetId)) {
            return dispatch({
                type: WIDGET_DATA_SUCCESS,
                payload: Object.assign({}, { widget: widgetId }, actionResult)
            });
        }
        let actions = (actionResult && actionResult.actions) || [];

        dispatch(webuiState.getActionByName("siren.dispatchSirenActions")(actions, widgetId, path));

        return Promise.resolve();
    };
}

function addEntities(targets, data) {
    return {
        type: "ADD_ENTITIES",
        payload: {
            targets,
            data
        }
    };
}

function loadMoreEntities(response, targets, widgetId, path) {
    return (dispatch, getState) => {
        if (response.hasOwnProperty("collectiveResponse")) {
            delete response.collectiveResponse;
            for (let key in response) {
                let targetEntities = getDependentPaths([key], getState(), path, widgetId);
                dispatch(addEntities(targetEntities, response[key]));
            }
        }

        return dispatch(addEntities(targets, response));
    };
}

//implements loadMore functionality, adding new data to existing entity
export function loadMore(action, widgetId, path) {
    return async (dispatch, getState) => {
        let state = getState();
        let targets = [extractStorePath(path, state)];

        if (action.hasOwnProperty("targets")) {
            targets = getDependentPaths(action.targets, state, path, widgetId);
            if (!targets.length) {
                WEBUILogs.warn("loadMore: Missing response targets:");
                return Promise.reject("loadMore: Missing response targets.");
            }
        }

        let sources = [widgetId];
        if (action.hasOwnProperty("sources")) {
            sources = action.sources.length ? action.sources : [];
        }
        let requestPayload = constructRequestEntity(sources, state, path, action, widgetId);

        let headers = { "Content-Type": action.contentType } || {
            "Content-Type": "multipart/form-data"
        };

        let endpoint = action.href;
        if (!endpoint) {
            endpoint = webuiState.getActionByName("widget.getWidgetUrl")(widgetId, getState());
        }

        let actionResult;

        try {
            //Note: The path variable represents the path inside of the widget of the triggering component.
            //Note: in some cases path may be missing in this cases we will not set loadingMore state.
            //Note: an example of missing path is when BE respond with actions => no triggering component.
            if (path) {
                dispatch(
                    setUiState(widgetId, path, {
                        loadingMore: true
                    })
                );
            }
            //requesting new entities
            let response = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: action.method || "POST",
                        endpoint: endpoint,
                        headers: headers,
                        payload: requestPayload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );

            actionResult = await dispatch(loadMoreEntities(response, targets, widgetId, path));
        } catch (error) {
            actionResult = Promise.reject(error);
        } finally {
            //deactivating loading animation
            if (path) {
                //Note: The path variable represents the path inside of the widget of the triggering component.
                //Note: in some cases path may be missing in this cases we will not set loadingMore state.
                //Note: an example of missing path is when BE respond with actions => no triggering component.
                dispatch(
                    setUiState(widgetId, path, {
                        loadingMore: false
                    })
                );
            }
        }

        return actionResult;
    };
}
//new format to manage the case to update a target property with a source one;
//properties: {
// componentProps: [value, label],
// dataProps: {
//   value: ""
// }
// }
export function updateComponent(sirenAction, widgetId, path) {
    let dependencies = sirenAction.dependencies || sirenAction.targets || [];
    let dependencyPaths = [];
    let properties = sirenAction.properties || {};
    let dataProperties = properties.dataProps || {};
    if (!dependencies.length) {
        return Promise.reject("updateComponentProperties action failed: missing dependecies.");
    }

    return async (dispatch, getState) => {
        dependencyPaths = getDependentPaths(dependencies, getState(), path, widgetId);

        if (!dependencyPaths.length) {
            return Promise.reject(
                "updateComponentProperties action failed: no correct dependencies found"
            );
        }
        let componentProps = properties.componentProps || [];
        let propertiesToSet = dataProperties;

        if (componentProps && componentProps.length) {
            let sources = sirenAction.sources;
            let sourcePath = path;
            if (sources && sources.length) {
                //expecting source is only one
                sourcePath = sources.includes("{self}") ? sourcePath : sources[0];
            }

            let sourceState = findInWidgetState(
                getState().getIn(["data", widgetId]),
                sourcePath.split(".")
            );
            let sourceProps = {};
            componentProps.forEach(prop => {
                sourceProps[prop] = sourceState.getIn(["properties", prop]);
                sourceState.getIn(["properties", prop]);
            });

            Object.assign(propertiesToSet, sourceProps);
        }

        await dispatch(triggerMultipleSetProperties(dependencyPaths, propertiesToSet));
        let loadInnerPromises = [];
        dependencyPaths.forEach(storePath => {
            let entityData = getState().getIn(["data", ...storePath]);
            let parentWidgetId = getStorePathWidgetId(storePath);
            if (entityData && entityData.toJS) {
                let widgetLoaded = loadInnerWidgets(dispatch, parentWidgetId, entityData.toJS(), {
                    recursive: false
                });
                loadInnerPromises.push(widgetLoaded);
            }
        });
        await Promise.all(loadInnerPromises);

        return Promise.resolve();
    };
}

export function updateComponentUiState(sirenAction, widgetId, path) {
    let dependencies = sirenAction.dependencies || sirenAction.targets || [];
    let properties = sirenAction.properties || {};

    if (!dependencies.length) {
        return Promise.reject("updateComponentUiState action failed: missing dependecies.");
    }

    if (!Object.keys(properties).length) {
        return Promise.reject("updateComponentUiState action failed: missing properties.");
    }

    return (dispatch, getState) => {
        let state = getState();

        let storePaths = getDependentPaths(dependencies, state, path, widgetId);
        if (!storePaths.length) {
            return Promise.reject(
                "updateComponentUiState action failed: no correct dependencies found"
            );
        }
        let entitiesProperties = storePaths.map(path => {
            let topWidget = widgetId;
            if (path.length === 1) {
                let entityPath = path[0];
                let topWidgetEntity = state.get("data").find(widgetEntity => {
                    let widgetClass = widgetEntity.get("class");
                    let success;
                    if (widgetClass && widgetClass.includes(entityPath)) {
                        success = true;
                    }
                    if (widgetEntity.get("widget") === entityPath) {
                        success = true;
                    }
                    return success;
                });

                topWidget = topWidgetEntity.get("class").first();
            }

            return {
                path: [topWidget, getEntityPath(path, state)],
                state: properties
            };
        });

        return dispatch(triggerMultipleSetUiState(entitiesProperties));
    };
}
